<template>
  <v-container
    ref="container"
    class="overflow-y-auto pa-0"
  >
    <v-row
      v-for="(item,index) in items"
      :key="item.uniqueKey"
    >
      <printer-item-simple-card
        :item="item"
        @pick="pick => $emit('pick', pick)"
      />
    </v-row>
  </v-container>
</template>

<script>
    import PrinterItemSimpleCard from "@/components/items/printer/PrinterItemSimpleCard";

    export default {
        name: "PrinterListItemSimpleCard",

        components: {PrinterItemSimpleCard},
        props: {
            items: {
                type: Array,
                default: () => [],
            },
        },
    }
</script>

<style scoped>

</style>